import React from 'react';
import tw, { css } from 'twin.macro';

interface Props {
  value: number;
  className?: string;
}

export default function ProgressBar(props: Props) {
  const { value, className } = props;
  return (
    <div className={className} tw="relative pt-1">
      <div tw="overflow-hidden h-2 text-xs flex rounded bg-neutral-moderate">
        <div
          css={[
            css`
              width: ${Math.round(value * 100)}%;
              background: linear-gradient(
                -45deg,
                rgba(255, 255, 255, 0.2) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.2) 50%,
                rgba(255, 255, 255, 0.2) 75%,
                transparent 75%
              );
            `,
            tw`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-brand-intense rounded`,
          ]}
        />
      </div>
    </div>
  );
}
